export default __webpack_public_path__ + "static/media/pm.b56ece89.svg";